import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileTabBar from "./MobileTabBar";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  return (
    <div id="top" className="flex min-h-screen w-full flex-col bg-background-950">
      <Navbar />
      <main className="w-full flex-1 pt-16 md:pt-[72px]">
        <Outlet />
      </main>
      <Footer />
      <div className="h-[68px] w-full md:hidden"></div>
      <MobileTabBar />
    </div>
  );
}